export class StreetAddressStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const info = JSON.parse(data);
            this.assertValid(info);
            return info;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        if (typeof data !== "object" ||
            data === null ||
            !("city" in data) ||
            !("street" in data) ||
            !("streetNumber" in data)) {
            throw new Error("Invalid street address data");
        }
    }
}
